import { hasOwnProperty, pick } from '../util.js';
import { Domain, PublicDomain } from './domains.js';
import { PublicStore } from './stores.js';
import { Product } from './products.js';
import { Flow, PublicFlow } from './flows.js';
import { PublicAccount } from './accounts.js';

export const dropProductKeys = new Set<keyof Product>([
	'cost',
	'paypal_category',
	'customs_description',
	'sanmar_product',
]);

const dropDomainKeys = new Set<keyof Domain>([
	'email_sender',
	'email_senders',
]);

const dropFlowKeys = new Set<keyof Flow>([
	'email',
	'email_subject',
	'email_body',
	'reprint_email',
	'reprint_email_subject',
	'reprint_email_body',
	'free_dropship_threshold',
	'dropship_price',
	'min_dropship_days',
	'max_dropship_days',
	'discount_formula',
]);

export function cleanUpDomain(domain: PublicDomain): PublicDomain {
	return pick(
		domain,
		'id',
		'host',
		'brand_name',
		'brand_slogan',
		'logo',
		'default_preview',
		'theme',
		'landing_url',
		'phone_number',
		'phone_text',
		'top_text',
		'double_header',
		'landing_title',
		'landing_description',
		'landing_keywords',
		'stylesheet_hash',
		'invoice_prefix',
		'sales_email',
		'service_email',
		'contact_email',
	);
}

export function cleanUpFlow(flow: PublicFlow): PublicFlow {
	return pick(
		flow,
		'id',
		'min_prod_days',
		'max_prod_days',
		'print_file_per',
		'graphics',
		'decoration',
		'min_raster_dpi',
		'color_profile',
		'color_ranges',
	);
}

export function cleanUpStore(store: PublicStore): PublicStore {
	return pick(
		store,
		'id',
		'domain',
		'name',
		'description',
		'links',
		'url',
		'twitch',
		'embed_twitch',
		'highlight_color',
		'free_us_shipping_from',
		'display_currency',
		'banners',
	);
}

export function cleanUpAccount(account: PublicAccount): PublicAccount {
	return pick(account, 'id', 'domain', 'account_name', 'avatar');
}

export const publicJSONReplacer = function (this: any, key: string, value: any) {
	if (key && hasOwnProperty(this, 'weight_oz') && dropProductKeys.has(key as any)) return undefined;
	if (key && hasOwnProperty(this, 'landing_url') && dropDomainKeys.has(key as any)) {
		console.warn(new Error('Domain leaked'));
		return undefined;
	}
	if (key && hasOwnProperty(this, 'stages') && dropFlowKeys.has(key as any)) {
		console.warn(new Error('Flow leaked'));
		return undefined;
	}
	if (key && hasOwnProperty(this, 'cart') && key == 'commissions') {
		return undefined;
	}
	return value;
};
